export const getters = {
    loadingProjects: state => state.loadingProjects,
    errorProjects: state => state.errorProjects,
    projects: state => state.projects,
    projectById: state => id => state.projects.find(project => project.id === id)
}